import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';
import { Snackbar } from '../interfaces/store/Snackbar';

export const snackbar = createSelector<ReduxStore, Snackbar, Snackbar>(
  state => state?.snackbar || [],
  value => value
);
